<template>
    <div class="container payment-result-container mt-5">
        <div class="row" v-if="!error && order">
            <div class="col-12 col-md-7 result-message">
                <div class="title-message success-message">
                    <img src="../../../assets/images/booking-success-icon.png" alt="">
                    <span>Đặt chỗ thành công</span>
                </div>
                <div class="hjbjw2 mt-5" v-if="bankAccounts && bankAccounts.length > 0">
                    <div class="title">
                        <div>Quý khách vui lòng thanh toán đơn hàng bằng cách nạp tiền theo hướng dẫn</div>
                    </div>
                    <div class="cMToPT mb-3" v-for="bank in bankAccounts" :key="bank.id">
                        <div class="ant-row">
                            <div class="ant-col ant-col-10">
                                Số tài khoản
                            </div>
                            <div class="ant-col ant-col-14 font-weight-bold">
                                {{getProp(bank, 'bank_id', '')}}
                            </div>
                        </div>
                        <div class="ant-row">
                            <div class="ant-col ant-col-10">
                                Chủ tài khoản
                            </div>
                            <div class="ant-col ant-col-14 font-weight-bold">
                                {{getProp(bank, 'owner', '')}}
                            </div>
                        </div>
                        <div class="ant-row">
                            <div class="ant-col ant-col-10">
                                Ngân hàng
                            </div>
                            <div class="ant-col ant-col-14 font-weight-bold">
                                {{getProp(bank, 'bank', '')}}
                            </div>
                        </div>
<!--                        <div class="ant-row">-->
<!--                            <div class="ant-col ant-col-10">-->
<!--                                Chi nhánh-->
<!--                            </div>-->
<!--                            <div class="ant-col ant-col-14 font-weight-bold">-->
<!--                                {{getProp(bank, 'bank_branch', '')}}-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="ant-row">
                            <div class="ant-col ant-col-10">
                                Nội dung chuyển khoản
                            </div>
                            <div class="ant-col ant-col-14 bxRQOX font-weight-bold color-danger">
                                {{bankingMessage}}
                            </div>
                        </div>
                        <div class="ant-row">
                            <div class="ant-col ant-col-10">
                                Số tiền
                            </div>
                            <div class="ant-col ant-col-14 bxRQOX font-weight-bold">
                                <span>{{getProp(order, 'total_price_pretty', '')}}<span class="currency-symbol">đ</span></span>
                            </div>
                        </div>
                      <div class="ant-row">
                        <div class="ant-col ant-col-10">
                          QR chuyển khoản
                        </div>
                        <div class="ant-col ant-col-14 bxRQOX font-weight-bold">
                          <img :src="genQrCode(bank)" alt="viet_qr" style="width: 100%" />
                        </div>
                      </div>
                    </div>
                    <div class="MuhUt color-danger mt-3"><b>* Lưu ý: Bắt buộc phải ghi nội dung chuyển khoản khi chuyển tiền.</b></div>
                    <div class="MuhUt color-danger mt-1"><b>* Nếu quên ghi nội dung chuyển khoản, hãy liên hệ: 19000 392 - 0972 111 112.</b></div>
                    <div class="MuhUt color-danger mt-1">* Vé của quý khách chỉ đuợc giữ chỗ trong <b>15 phút</b>. Vui
                        lòng thanh toán, nếu không vé của quý khách sẽ bị hủy.
                    </div>
                </div>

                <div class="thank-message">
                    <div class="title">
                        <div>Cảm ơn quý khách {{getProp(order, 'customer.name', '')}}!</div>
                    </div>
                    <div class="content">
                        <span>Cảm ơn bạn đã tin tưởng sử dụng dịch vụ của
                            <a href="https://hoangcongcar.com/" target="_blank">hoangcongcar.com</a>
                            . Bạn có thể kiểm tra vé của mình trong phần <router-link :to="{name: hcRoutes.order}">Quản lí vé</router-link>.
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4 ticket-info-container">
                <div class="ticket-info">
                    <div class="title">
                        <div class="ticket-info-success-title">
                            <span>Thông tin vé  </span>
                            <span class="ticket-code">{{getProp(order, 'transaction.id', '')}}</span>
                        </div>
                    </div>
                    <div class="content">
                        <div class="info-item">
                            <div class="info-label">
                                <span>Tuyến:</span>
                            </div>
                            <div class="info-value">
                                <strong>{{getProp(order, 'schedule.voyage.from', '')}} - {{getProp(order, 'schedule.voyage.to', '')}}</strong>
                            </div>
                        </div>

                        <div class="info-item">
                            <div class="info-label">
                                <span>Thời gian:</span>
                            </div>
                            <div class="info-value">
                                <strong>{{format(new Date(getProp(order,
                                    'schedule.start_time', 0)), 'HH:mm')}}
                                    - {{format(new Date(getProp(order,
                                    'schedule.end_time', 0)), 'HH:mm dd/MM/yyyy')}}</strong>
                            </div>
                        </div>

                        <div class="info-item">
                            <div class="info-label"><span>Điểm đón:</span></div>
                            <div class="info-value">
                                <strong>{{getProp(order, 'pick_up_locations', []).map(pickup => pickup.address).join(', ')}}</strong>
                            </div>
                        </div>

                        <div class="info-item">
                            <div class="info-label"><span>Điểm trả:</span></div>
                            <div class="info-value">
                                <strong>{{getProp(order, 'get_off_locations', []).map(getOff => getOff.address).join(', ')}}</strong>
                            </div>
                        </div>

                        <div class="info-item">
                            <div class="info-label">
                                <span>Số ghế:</span>
                            </div>
                            <div class="info-value">
                                <strong>{{getProp(order, 'seats', []).map(seat => getProp(seat, 'p_row', '') + '.' + getProp(seat, 'p_col', '')).join(', ')}}</strong>
                            </div>
                        </div>

                        <div class="info-item blank"></div>

                        <div class="info-item">
                            <div class="info-label">
                                <span>Khách:</span>
                            </div>
                            <div class="info-value">
                                <strong>{{getProp(order, 'customer.name', '')}}</strong>
                            </div>
                        </div>

                        <div class="info-item">
                            <div class="info-label">
                                <span>Điện thoại:</span>
                            </div>
                            <div class="info-value">
                                <strong>{{getProp(order, 'customer.phone_number', '')}}</strong>
                            </div>
                        </div>

                        <div class="info-item blank"></div>

                        <div class="info-item total-price">
                            <div class="info-label">
                                <strong><span>Tổng tiền:</span></strong>
                            </div>
                            <div class="info-value">
                                <div><strong><span>{{getProp(order, 'total_price_pretty', '')}}<span class="currency-symbol">đ</span></span></strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="error">
            <div class="text-center mt-5">
                <div>
                    <img src="../../../assets/images/icon-error.png" alt="" width="100px">
                    <h1 class="mt-4">Thất bại</h1>
                    <p>{{error}}</p>
                    <p>Quý khách vui lòng thử lại sau</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {RepositoryFactory, MixinHelper, eventBus, EVENTS} from "../../shared/services";
    import format from "date-fns/format";
    import {HCROUTES, PaymentMethod} from '../../shared/constants/Constant';

    const repo = RepositoryFactory.get('orders');
    const repoBank = RepositoryFactory.get('bank');
    export default {
        name: "Result",
        mixins: [MixinHelper],
        data() {
            return {
                order: null,
                format,
                error: null,
                paymentMethod: null,
                paymentMethodDefault: PaymentMethod,
                bankAccounts: [],
                hcRoutes: HCROUTES
            }
        },
        created() {
            const order_id = this.getProp(this.$route.params, 'order_id', 0);
            this.singleOrder(order_id);
            this.error = this.getProp(this.$route.query, 'message', null);
            this.paymentMethod = this.getProp(this.$route.query, 'payment_method', null);
            if (this.paymentMethod && this.paymentMethod === PaymentMethod.bank_transfer) {
                this.getBankAccounts();
            }
        },
        methods: {
            singleOrder(order_id) {
                repo.single(order_id)
                    .then(resp => {
                        this.order = this.getProp(resp, 'data.data', null);
                        if (!this.order) {
                            eventBus.$emit(EVENTS.not_found)
                        }
                    })
                    .catch(() => {
                        eventBus.$emit(EVENTS.not_found);
                    })
            },
            getBankAccounts() {
                repoBank.account()
                    .then(resp => {
                        this.bankAccounts = this.getProp(resp, 'data.datas', []);
                    })
                    // eslint-disable-next-line no-console
                    .catch(err => console.log(err));
            },
            genQrCode(bankAccount) {
              if (!bankAccount || !this.order) {
                return '';
              }
              return `https://img.vietqr.io/image/${bankAccount.vietqr_bank_code}-${bankAccount.bank_id}-print.jpg?amount=${this.order.total_price}&addInfo=${this.bankingMessage}&accountName=${bankAccount.owner}`;
            },
            getBankingMessage() {

            }
        },
        beforeDestroy() {
            eventBus.$emit(EVENTS.off_not_found_page);
        },
        computed: {
          bankingMessage() {
            if (!this.order) {
              return '';
            }
            return `${this.order.customer.name} - ${this.order.customer.phone_number} - ${this.order.transaction.id}`;
          }
        }
    }
</script>

<style scoped>
    .title-message {
        width: 100%;
        height: 45px;
        padding: 10px;
        border-radius: 5px;
    }

    .success-message {
        border: 1px solid #095aa9;
    }

    .success-message span {
        color: #095aa9;
        margin-left: 10px;
    }

    .thank-message .title {
        text-align: center;
        font-size: 24px;
        font-weight: 700;
        margin-top: 35px;
    }

    .thank-message .content {
        margin-bottom: 30px;
    }

    .payment-result-container .result-message .title {
        font-size: 20px;
        color: #095aa9;
        font-weight: 700;
        margin-bottom: 15px;
    }

    .thank-message div {
        margin-top: 15px;
    }

    .payment-result-container .ticket-info {
        padding-left: 0;
        padding-right: 0;
        height: auto;
    }

    .payment-result-container .ticket-info .title {
        background: #095aa9;
        height: 45px;
        color: #fff;
        font-size: 15px;
        padding: 15px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }

    .ticket-info-success-title .ticket-code {
        color: #f8c13b;
    }

    .payment-result-container .ticket-info .content {
        padding: 10px 10px 10px 15px;
        border: 1px solid #1867aa;
    }

    .payment-result-container .ticket-info .content .info-item {
        width: 100%;
        display: flex;
        margin-bottom: 10px;
        min-height: 22px;
    }

    .payment-result-container .ticket-info .content .info-item div {
        display: inline-block;
    }

    .payment-result-container .ticket-info .content .info-item .info-label {
        width: 30%;
    }

    .payment-result-container .ticket-info .content .info-item .info-value {
        width: 70%;
    }

    .blank {
        height: 1px;
        width: 100%;
        background-color: #a6a6a6;
    }

    .payment-result-container .ticket-info .content .blank {
        border: 1px solid #eee;
        margin-bottom: 20px;
        min-height: 1px;
    }

    .total-price .info-label {
        color: #095aa9;
        font-size: 16px;
    }
    .total-price .info-value {
        color: #f8c13b;
        text-align: right;
        font-size: 16px;
    }
</style>
